/**
 * monsterDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const monsterDesignsPack: ToilePack = {
    slug: 'monster-designs',
    category: 'monsters',
    name: 'Monster design sheets',
    tagline: tagline('sheets', 'monsters', 'treatments'),
    chips: chips('monsters', 'treatments'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'lurker', label: 'Swamp lurker', subject: 'a long-limbed ambush predator, mottled algae-green hide, webbed claws'},
        {key: 'leviathan', label: 'Sky leviathan', subject: 'a whale-bodied floating creature, membranous fins and gas bladders'},
        {key: 'mimic', label: 'Cave mimic', subject: 'a mossy boulder splitting open on a ringed maw of stone teeth'},
    ],
    styles: [
        {key: 'painted', label: 'Painted concept', style: 'a full-color painting, rendered skin and wet highlights', palette: 'soft even studio light', framing: 'several angles, a human silhouette for scale'},
        {key: 'sketch', label: 'Ink sketch page', style: 'loose ballpoint and brush-pen exploration', palette: 'off-white paper', framing: 'head and limb variations around the main drawing'},
        {key: 'anatomy', label: 'Anatomical study', style: "a naturalist's plate with a skeletal view", palette: 'sepia ink and light wash on aged paper', framing: 'detail insets of a claw and the jaw'},
    ],
    directions: ['a desert burrower instead', 'in cold blue-grey tones', 'smaller, hunting in a pack'],
}
